// import { AccountServiceProxy } from "@/asdcom/apiproxy/apiproxy.Account"
// import { TokenAuthServiceProxy } from "./apiproxy/apiproxy.TokenAuth"
// import { CustomerUserProfileServiceProxy } from "./apiproxy/apiproxy.CustomerUserProfile"
// import { ProfileServiceProxy } from "./apiproxy/apiproxy.Profile"
// import { VcpOnlineOkServiceServiceProxy } from "./apiproxy/apiproxy.VcpOnlineOkService"
// import { SessionServiceProxy } from "./apiproxy/apiproxy.Session"
// import { ContactUsServiceServiceProxy } from "./apiproxy/apiproxy.ContactUsService"
// import { NotificationServiceProxy } from "./apiproxy/apiproxy.Notification"
// import { LookupsServiceProxy } from "./apiproxy/apiproxy.Lookup"
// import { PublicContactRequestsServiceProxy } from "./apiproxy/apiproxy.PublicContactRequests"
// import { VcpOnlineOkStaffServiceProxy } from "./apiproxy/apiproxy.VcpOnlineOkStaff"
import {
  IUserLoginInfoDto,
  ChangePasswordInput,
  IAuthenticateResultModel,
  SetSecurityQuestionsInput,
  ISetSecurityQuestionsInput,
  AuthenticateModel,
  UserNotificationState,
  VcSubmissionDtoOfApplicationDto,
  PagedAndSortedInputDto,
  VcClaimDto,
  IVcClaimDto
} from "./apiproxy/apiproxy.dto"
import {
  AccountServiceProxy,
  TokenAuthServiceProxy,
  CustomerUserProfileServiceProxy,
  ProfileServiceProxy,
  VcpOnlineOkServiceServiceProxy,
  SessionServiceProxy,
  ContactUsServiceServiceProxy,
  NotificationServiceProxy,
  LookupsServiceProxy,
  PublicContactRequestsServiceProxy,
  VcpOnlineOkStaffServiceProxy,
  VpBoxStaffServiceProxy,
  VpBoxCustomerServiceProxy,
} from "./apiproxy/generated.apiproxy.services"

import { AbpApiResponse } from "@/store/models/common"
import AppConsts from "@/lib/appconst"
import util from "@/lib/util"
import moment from "moment"

export namespace Asdcom {

  // class StoreHelper{
  //   public static get customerFlags():CustomerUserProfileStateDto{
  //     return this.store
  //   }
  // }

  export interface ILoginResponse {
    authenticateSuccessModel?: IAuthenticateResultModel
    emailIsNotVerified: boolean
    username: string
  }


  // export class LookupAppService extends LookupsServiceProxy {
  //   constructor() {
  //     super()
  //   }
  // }

  export class TokenAuthAppService extends TokenAuthServiceProxy {
    constructor() {
      super()
    }

    //public async authenticate(authModel: IAuthenticateModel): Promise<AuthenticateResultModel> {
    public async loginStaff(model: AuthenticateModel): Promise<ILoginResponse> {
      //this.store.commit("asdcom/app/authInitiated",  loginModel )
      let ret = { username: model.userNameOrEmailAddress, emailIsNotVerified: false } as ILoginResponse
      // return super.authenticate(model)
      return super.authenticateStaffOrAdminUser(model)
        .then(authRes => {
          abp.log.debug({ "Authenticate result": authRes })

          // let rep = await ajax.post<AbpApiResponse<AuthenticateResultModel>>("/api/TokenAuth/Authenticate", payload.data)
          // if (rep.data.result == undefined) {
          //   return rep
          // }

          const tokenDurationSec = authRes.expireInSeconds || AppConsts.accessTokenDefaultExpirationSeconds
          // const tokenDurationSec = 120;
          //const tokenExpireDate = payload.data.rememberMe ? new Date(new Date().getTime() + 1000 * tokenDuration) : undefined;
          const tokenExpireDate = new Date(new Date().getTime() + 1000 * tokenDurationSec)

          util.abp.auth.setToken(authRes.accessToken, tokenExpireDate)
          util.abp.utils.setCookieValue(AppConsts.authorization.encrptedAuthTokenName, authRes.encryptedAccessToken, tokenExpireDate, util.abp.appPath)
          util.abp.utils.setCookieValue("userId", authRes.userId, tokenExpireDate, util.abp.appPath)

          // store token values
          this.store.commit("asdcom/app/tokenExpiration", { tokenExpDate: tokenExpireDate })
          this.store.commit("asdcom/app/tokenDuration", { tokenDurationSeconds: tokenDurationSec })
          //localStorage.setItem(appconst.authorization.tokenDurationSecondsName, tokenDurationSec.toString());

          // IMPORTANT: must reload app on login.
          location.reload(true);

          ret.authenticateSuccessModel = authRes;
          return Promise.resolve(ret);
        })
        .catch((response: AbpApiResponse) => {
          abp.log.debug({ "TokenAuthAppService.login error": response })

          const errorCode = !!response.error ? response.error.code : 0

          // if error is unverified email
          abp.log.error("TODO: update value to constant")
          if (
            //TODO: replace this code with constant.
            //errorCode == util.abp.constant.apiErrorCodesEnum.unverifiedEmail
            errorCode == 100
          ) {
            ret.emailIsNotVerified = true
          }
          return Promise.resolve(ret)
        })
    }

    async logOut() {
      const res = await super.logOut();
      this.store.commit("asdcom/app/logout");
      return res;
    }

    async refreshAuthToken() {
      const rep = await super.refreshJWTToken();
      abp.log.debug({ "refreshAuthToken": rep });

      const tokenDuration: number = this.store.getters["asdcom/session/tokenDurationSeconds"];
      const tokenExp = new Date(new Date().getTime() + 1000 * tokenDuration);

      if (tokenExp != undefined) {
          // update token value.
          util.abp.auth.setToken(rep, tokenExp);
          //util.abp.utils.setCookieValue(appconst.authorization.encrptedAuthTokenName, rep.data.result.encryptedAccessToken, tokenExpireDate, util.abp.appPath);

          // store new expiration.
          this.store.commit("tokenExpiration", { tokenExpDate: tokenExp })
      } else{
        this.logOut();
      }
    }
  }

  export class LookupsAppService extends LookupsServiceProxy {
    constructor() {
      super()
    }
  }

  export class AccountAppService extends AccountServiceProxy {
    constructor() {
      super()
    }

    public setSecurityQuestions(input: ISetSecurityQuestionsInput | null | undefined) {
      return super.setSecurityQuestions(input as SetSecurityQuestionsInput).then(() => {
        this.store.commit("asdcom/app/userProfileFlagsChange", null);
      });
    }
  }

  export class ProfileAppService extends ProfileServiceProxy {
    constructor() {
      super()
    }

    public updatePassword(input?: ChangePasswordInput | null | undefined): Promise<number> {
      throw "ProfileAppService.changePassword not implemented. Input accepts old and new password only."
    }
  }

  export class CustomerUserProfileAppService extends CustomerUserProfileServiceProxy {
    constructor() {
      super()
    }

    public async getCustomerUserProfileReadyFlags() {
      /// check if flags available in store.
      let ret = this.store.state.asdcom.app.userProfileFlags;  //as ICustomerUserProfileStateDto; 
      abp.log.debug({ "getCustomerUserProfileReadyFlags store": !!ret })
      // if (!!ret) {
      return super.getCustomerUserProfileReadyFlags().then(flags => {
        /// store flags.
        this.store.commit("asdcom/app/userProfileFlagsChange", flags)
        return flags;
      })
      // } else {
      //   return Promise.resolve(ret)
      // }
    }

    public async requestClaimAccess() {
      throw "API for claim access request not implemented yet."
    }
  }

  export class ContactUsAppService extends ContactUsServiceServiceProxy {
    constructor() {
      super(asdcom.config.hostUrlOcvcApp)
    }

    // public contactUs(input?: ICreateContactUsDto | null | undefined): Promise<number> {
    //   throw "ContactUsService.contactUs Not Implemented."
    // }
  }

  export class PublicContactRequestsAppService extends PublicContactRequestsServiceProxy {
    constructor() {
      super()
    }
  }

  export class SessionAppService extends SessionServiceProxy {
    constructor() {
      super()
    }
    
    public async initialize() {
      // call original init store action.
      await this.store.dispatch("session/init")

      const user = this.store.state.session.user as IUserLoginInfoDto
      this.store.commit("asdcom/session/newSession", user)
    }

  }

  export class NotificationAppService extends NotificationServiceProxy {
    constructor() {
      super()
    }

    public async getUserNotifications(state?: UserNotificationState | undefined, startDate?: moment.Moment | undefined, endDate?: moment.Moment | undefined, maxResultCount?: number | undefined, skipCount?: number | undefined) {
      const resp = await super.getUserNotifications(state, startDate, endDate, maxResultCount, skipCount)

      if (resp.unreadCount !== this.store.state.session.newNotifCount) {
        this.store.commit("asdcom/session/newNotificationsChanged", { newNotifications: resp })
      }
      return resp
    }
  }

  export class VcpOnlineOkService extends VcpOnlineOkServiceServiceProxy {
    constructor() {
      super()
    }

    async startNewApplication(): Promise<VcSubmissionDtoOfApplicationDto> {
      const res = await super.startNewApplication();
      localStorage.setItem("activeApplication", JSON.stringify(res, (k, v) => v === undefined ? null : v));
      localStorage.setItem("activeApplicationId", JSON.stringify(res.id));
      this.store.commit("vcponlineok/setActiveApplication", res)
      return res
    }

    public get activeApplicationId(): string | null {
      let appId = localStorage.getItem("activeApplicationId");
      if (!!appId) {
        return appId;
      } else {
        return null
      }

      //   return localStorage.getItem("activeApplicationId");
      // }
      // public setActiveApplicationId(applicationId: number) {
      //   localStorage.setItem("activeApplicationId", applicationId.toString());
    }

    public async getApplication(id: number) {
      // this.setActiveApplicationId(0);
      let app = new VcSubmissionDtoOfApplicationDto();
      // if (!!this.store.state && !!this.store.state.activeApplication) {
      //   app = this.store.state.activeApplication.submissionData
      // } else {
      let appAsString = localStorage.getItem("activeApplication") as string;
      app = JSON.parse(appAsString);
      // }
      return app
      throw "getApplication not implemented. Waiting for API."
    }

    async putApplication(input: VcSubmissionDtoOfApplicationDto): Promise<VcSubmissionDtoOfApplicationDto> {
      let res = await super.putApplication(input)
      localStorage.setItem("activeApplication", JSON.stringify(res, (k, v) => v === undefined ? null : v));
      this.store.commit("vcponlineok/setActiveApplication", res)
      return res
    }
  }

  export class VcpOnlineOkStaffService extends VcpOnlineOkStaffServiceProxy {
    constructor() {
      super()
    }

    async retrieveVcClaimForStaff(claimNumber?: string | null | undefined): Promise<VcClaimDto> {
      // var retClaim: VcClaimDto | null = null;
      // const claimStorageKey = "staff:last-claim-retrieved";

      // let claimStorage = localStorage.getItem(claimStorageKey);
      // if (!!claimStorage) {
      //   const storageObj = JSON.parse(claimStorage);
      //   retClaim = new VcClaimDto(storageObj);
      // }

      // if (!retClaim || retClaim.claimNumber != claimNumber) {
        const res: VcClaimDto = await super.retrieveVcClaimForStaff(claimNumber);
        abp.log.debug({ "retrieveVcClaimForStaff claim": { res } });
        this.store.commit("vcponlineok/setCurrentClaim", res);
        return res;
        // let claimObj = <IVcClaimDto>retClaim;
        // localStorage.setItem(claimStorageKey, JSON.stringify(claimObj))
      // }


      // return Promise.resolve(retClaim);
    }

    async retrieveAndCachApplicantRequests() {
      var res = await super.retrieveApplicantRequests();
      this.store.commit("vcponlineok/applicantRequestTaskList", res.applicantsTasks);
    }

    async refreshTaskCounts() {
      const res = await super.retrieveTaskCounts();
      this.store.commit("vcponlineok/setDashboardCounts", res);
    }
  }

  export class StaffVpBoxService extends VpBoxStaffServiceProxy {
    constructor() {
      super();
    }
  }
}
